import React, { Children, cloneElement, isValidElement } from 'react';
import styled, { css } from 'styled-components/macro';

import { trackingId, rem } from '@blueprint/ui';

import Box from '../Box';

const ListWrapper = styled(Box)`
  ${({ listStylePosition, listStyleColor }) =>
    listStylePosition &&
    listStyleColor === 'default' &&
    css`
      list-style-position: ${listStylePosition};
    `};
  ${({ listStyleType }) =>
    listStyleType &&
    css`
      list-style-type: ${listStyleType};
    `};
  ${({ listStyleType }) =>
    listStyleType !== 'none' &&
    css`
      padding-left: ${rem(15)};
    `};
`;

const List = ({
  container,
  children,
  subHeader,
  ordered,
  customIcon = false,
  listStyleType = 'disc',
  listStyleColor = 'default',
  listStylePosition = 'outside',
  ...rest
}) => {
  const component = ordered ? 'ol' : 'ul';

  return (
    <ListWrapper
      as={component}
      data-trackid={container && trackingId('List')}
      data-testid={container && 'List'}
      listStyleType={listStyleType}
      listStylePosition={listStylePosition}
      listStyleColor={listStyleColor}
      {...rest}
    >
      {subHeader && <Box>{subHeader}</Box>}
      {!!children &&
        Children.map(children, (child) => {
          // @ts-ignore

          if (isValidElement(child)) {
            return cloneElement(child, {
              listStylePosition,
              customIcon,
              listStyleColor,
              listStyleType,
            });
          }

          return child;
        })}
    </ListWrapper>
  );
};

List.displayName = 'List';

export default List;
